import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=1bc3f951&scoped=true&"
import script from "./mainTitle.vue?vue&type=script&lang=js&"
export * from "./mainTitle.vue?vue&type=script&lang=js&"
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=1bc3f951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc3f951",
  null
  
)

export default component.exports